<template>
  <div>
    <div class="login-wrap" v-show="signIn">
      <img style=" position: absolute;   width: 318px;
    top: 50px;
    left: 50px;
    z-index: -1;" src="../assets/logo_bg.png"  />
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
               class="demo-ruleForm login-container">
        <el-form-item>
          <el-tabs v-model="ruleForm.type" @tab-click="handleClick">
            <el-tab-pane label="个人登录" name="1">个人登录</el-tab-pane>
            <el-tab-pane label="单位登录" name="2">单位登录</el-tab-pane>
          </el-tabs>
        </el-form-item>

        <el-form-item prop="account">
          <el-input type="text" v-model="ruleForm.account" auto-complete="off"
                    placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input :type="passwordShow" show-password v-model="ruleForm.password" auto-complete="off"
                    placeholder="请输入密码">
          </el-input>
        </el-form-item>
        <div class="bottom_box">
          <el-checkbox class="remember" v-model="rememberpwd">自动登录</el-checkbox>
          <span class="wjpass" @click="open">忘记密码？</span>
        </div>
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;background: #E40080;border:#E40080;height: 52px "
                     @click="submitForm('ruleForm')" :loading="logining">登录
          </el-button>
        </el-form-item>
        <el-form-item style="width:100%;margin: 10px 0 !important;">
          <div class="register_class _center" @mouseenter="imgUrlMouseenter" @mouseleave="imgUrlMouseleave"
               @click="registerClick()">
            用户注册
            <img height="10px" :src="imgUrl" alt="">
          </div>
        </el-form-item>
        <div style="width:100%;text-align: center;font-size: 12px;color:red">
          申请会员请先完成用户注册再登录
        </div>
      </el-form>

    </div>
    <!--    注册-->
    <div class="login-wrap" v-show="!signIn">
      <div class="register_box">
        <div style="margin: auto;display: flex">
          <el-form label-position="left" :model="registerForm" :rules="registerRules" ref="registerRef"
                   label-width="0px"
                   style="width: 367px;">
            <el-form-item>
              <div style="display: flex;flex-direction: column;">
                <span style="font-weight: 500;font-size: 18px;color: #000000;line-height: 25px">用户注册</span>
                <div style="border-bottom: 3px solid #E40080;width: 50px;"></div>
              </div>
            </el-form-item>

            <el-form-item prop="type">
              <el-select style="width: 100%" v-model="registerForm.type" placeholder="请选择会员类型" clearable
                         @change="type_change">
                <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="committee_id">
              <el-select style="width: 100%" v-model="registerForm.committee_id" placeholder="专委会选择" clearable
                         @change="committeeTitle">
                <el-option
                    v-for="item in ccompanyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="account">
              <el-input type="text" v-model="registerForm.account" auto-complete="off"
                        placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item prop="img_code" class="verification">
              <el-input type="text" v-model="registerForm.img_code" auto-complete="off"
                        placeholder="请输入右侧验证码">
              <span slot="suffix" style="height: 75px;line-height: 75px">
              <img style="cursor: pointer; width: 130px;margin: 5px 0" :src="image" title="验证码点击刷新"
                   alt="点击刷新" @click="getImg_code"/>
              </span>

              </el-input>
              <!--              <el-button type="info" style="border: none;border-radius: 8px;margin-left: 10px">获取验证码</el-button>-->

            </el-form-item>
            <el-form-item prop="sms_code" class="verification">
              <el-input type="text" v-model="registerForm.sms_code" auto-complete="off"
                        placeholder="请输入验证码">
              <span slot="suffix">
           <span
               style="font-weight: 400;font-size: 14px;color: #1677FF;line-height: 52px; cursor: pointer;"
               v-if="countdown==60"
               @click="getFlag('YZMDL',registerForm)">获取验证码</span>
              <span v-else style="font-weight: 400;font-size: 14px;line-height: 52px;">已发送（{{ countdown }}s）</span>
              </span>

              </el-input>
              <!--              <el-button type="info" style="border: none;border-radius: 8px;margin-left: 10px">获取验证码</el-button>-->

            </el-form-item>
            <el-input type='text' v-model="password" auto-complete="off"
                      placeholder="请输入密码" style="position: absolute; z-index: -9999999">
            </el-input>
            <el-input :type="passwordShow" show-password v-model="password" auto-complete="off"
                      placeholder="请输入密码" style="position: absolute;  z-index: -9999999">
            </el-input>

            <el-form-item prop="password">
              <el-input :type="passwordShow" show-password v-model="registerForm.password" auto-complete="off"
                        placeholder="请输入密码">
              </el-input>
            </el-form-item>
            <el-form-item prop="password_confirm">
              <el-input :type="passwordShow" show-password v-model="registerForm.password_confirm" auto-complete="off"
                        placeholder="请再次输入密码">
              </el-input>
            </el-form-item>
            <el-form-item prop="agree">
              <div style="display:flex;">
                <el-checkbox style="color: #A9ABBA;" v-model="agree">我已阅读并同意
                </el-checkbox>
                <div style="cursor: pointer" @click="open_see">《隐私协议》</div>
              </div>
            </el-form-item>

            <el-form-item style="width:100%;">
              <el-button type="primary" style="width:100%;background: #E40080;border:#E40080;height: 52px "
                         @click="RegisterAnAccount('registerRef')" :loading="logining">注册
              </el-button>
            </el-form-item>
            <div @click="registerClick"
                 style="display: flex;align-items: center;position: absolute;left: 50px;cursor: pointer">
              <img width="30px" src="../assets/goBack.png">
              <span style="font-size: 13px">返回</span>
            </div>

          </el-form>
          <div class="register_line"></div>
          <div class="register_right">
            <div>
              <!--            <div class="register_class top_link" @click="link_Click(17)">-->
              <!--              中国服装设计师协会简介-->
              <!--              <span class="el-icon-d-arrow-right"></span>-->
              <!--            </div>-->
              <div class="register_class top_link" @click="link_Click(17)">
                协会简介 <span class="el-icon-d-arrow-right"></span>
              </div>
              <!--            <div class="register_class top_link" @click="link_Click(3)">-->
              <!--              会员管理办法 <span class="el-icon-d-arrow-right"></span>-->
              <!--            </div>-->
              <div class="register_class top_link" @click="link_Click(18)">
                入会条件 <span class="el-icon-d-arrow-right"></span>
              </div>
              <div class="register_class top_link" @click="link_Click(19)">
                入会流程 <span class="el-icon-d-arrow-right"></span>
              </div>
              <div class="register_class top_link" @click="link_Click(20)">
                如何选择委员会及所需上传资料 <span class="el-icon-d-arrow-right"></span>
              </div>
              <div class="register_class top_link" @click="link_Click(29)">
                会员权益 <span class="el-icon-d-arrow-right"></span>
              </div>

            </div>

            <div class="bottom_view">
              <div>联系方式</div>
              <div>会员部 010-84562288-407</div>
              <div>zhanglm@fashion.org.cn</div>
              <div>北京市朝阳区酒仙桥路4号</div>
              <div>798·751园区时尚设计广场中央大厅A座</div>
            </div>

          </div>
        </div>

      </div>

    </div>
    <el-dialog
        :close-on-click-modal="false"
        title=""
        :visible.sync="top_link_show"
        width="700px"

    >
      <div class="poster" v-html="top_link_content"></div>
      <!--      <span slot="footer" class="dialog-footer">-->
      <!--    <el-button type="primary" @click="top_link_show = false" size="medium">我已知悉</el-button>-->
      <!--     </span>-->
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title="忘记密码"
        :visible.sync="dialogVisible"
        width="440px"
    >
      <el-form :model="forget_form" :rules="forget_form_rules" ref="forget_form_ref">
        <el-form-item prop="account">
          <el-input type="text" v-model="forget_form.account" auto-complete="off"
                    placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="img_code" class="verification">
          <el-input type="text" v-model="forget_form.img_code" auto-complete="off"
                    placeholder="请输入右侧验证码">
              <span slot="suffix" style="height: 75px;line-height: 75px">
              <img style="cursor: pointer; width: 130px;margin: 5px 0" :src="image" title="验证码点击刷新"
                   alt="点击刷新" @click="getImg_code"/>
              </span>
          </el-input>
        </el-form-item>
        <el-form-item prop="sms_code" class="verification">
          <el-input type="text" v-model="forget_form.sms_code" auto-complete="off"
                    placeholder="请输入验证码">
              <span slot="suffix">
           <span
               style="font-weight: 400;font-size: 14px;color: #1677FF;line-height: 52px; cursor: pointer;"
               v-if="countdown==60"
               @click="getFlag('ZHDLMM',forget_form)">获取验证码</span>
              <span v-else style="font-weight: 400;font-size: 14px;line-height: 52px;">已发送（{{ countdown }}s）</span>
              </span>

          </el-input>
        </el-form-item>
        <el-input type='text' v-model="password" auto-complete="off"
                  placeholder="请输入密码" style="position: absolute; width: 10px; z-index: -9999999">
        </el-input>
        <el-input :type="passwordShow" show-password v-model="password" auto-complete="off"
                  placeholder="请输入密码" style="position: absolute; width: 10px; z-index: -9999999">
        </el-input>
        <el-form-item prop="password">
          <el-input :type="passwordShow" show-password v-model="forget_form.password" auto-complete="off"
                    placeholder="请输入密码">
          </el-input>
        </el-form-item>
        <el-form-item prop="password_confirm">
          <el-input :type="passwordShow" show-password v-model="forget_form.password_confirm" auto-complete="off"
                    placeholder="请再次输入密码">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :disabled="logining" type="primary" @click="forgotPasswd('forget_form_ref')">确 定</el-button>
      </div>

    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title=""
        :visible.sync="committee_text_show"
        width="480px"

    >
      <div
          style="position: absolute;top: -20px;right: 160px; width: 160px;height: 42px;border-radius: 8px 35px 8px 35px; border: 1px solid #FFFFFF; background-color: #E40080;color: #fff;font-size: 14px;text-align: center;line-height: 42px ">
        {{ registerForm.committee_title }}
      </div>
      <!--      <div class="poster" v-html="committee_text"></div>-->
      <div style="text-align: center">{{ synopsis }}</div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="committee_text_show = false" size="medium">我已知悉</el-button>
  </span>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title=""
        :visible.sync="Privacy_Agreement_show"
        width="700px"

    >
      <div class="Privacy_box">
        <div>会员系统网站注册以及隐私协议</div>
        <div>
          为做好中国服装设计师协会会员系统登记、审核、统计分析等工作，在注册系统时需要您填写相关信息，用于【中国服装设计师协会会员系统信息的录入、备案、审核、比对、统计分析等】。为保障您提供的信息安全，请务必仔细阅读并理解本协议内容：
        </div>
        <div> 一、接受条款</div>
        <div>
          1、请您在同意本协议内容后，按照网站提示完成注册流程，当您在本网站注册您的个人/单位账户时，视为您已阅读并且同意接受本协议的所有内容。
        </div>
        <div>
          2、中国服装设计师协会保留对本协议不定期修改、更新的权利，修改、更新后的隐私保护条款一旦在本网站上公布即有效代替原来的隐私保护条款。
        </div>
        <div> 二、会员注册</div>
        <div> 1、当您在本网站注册为会员时，须提供【个人基本信息、教育工作背景、专业背景、奖项业绩等】必要注册信息。</div>
        <div>
          2、对于个人会员，须提供您的真实姓名、住址、国籍、【个人身份证明文件、学历信息、职务信息、证件照】、电话号码和电子邮件地址等。
        </div>
        <div>
          3、个人会员均需对您提供的注册信息的真实性、准确性和完整性负责且不得侵害任何第三方的合法权益。否则，本网站有权暂停或停止提供服务。
        </div>
        <div>4、注册会员须为具备完全民事能力的自然人活或者依法成立的单位。</div>
        <div>
          若您未满14周岁，请您在监护人同意下注册、使用本网站。如发现未经监护人同意的未成年人信息，我们将采取措施删除相关信息。
        </div>
        <div>
          5、会员应妥善保管注册账号和密码，不得将其转让、赠与或租赁给他人使用。若发现任何非法或不正当使用账号的行为，会员应及时通知网站并采取措施防止损失扩大。
        </div>
        <div> 三、会员权益与义务</div>
        <div> 1. 会员享有以下权利:</div>
        <div> (1)合法、正当地使用网站服务；</div>
        <div> (2)对网站服务提出改进意见和建议。</div>
        <div> 2.会员应履行以下义务</div>
        <div> （1）遵守法律法规，不得发布违法、违规信息;</div>
        <div> （2）遵守网站规定，不得干扰网站正常运营；</div>
        <div> （3）尊重他人权益，不得侵犯他人知识产权。</div>
        <div> 3、若会员违反本协议规定，本网站有权采取以下一种或多种措施：</div>
        <div> （1）暂停或终止提供服务</div>
        <div> （2）删除违规信息；</div>
        <div> （3）追究法律责任。</div>
        <div> 若因会员行为导致本网站或中国服装设计师协会损失的，会员应承担相应的赔偿责任。</div>
        <div> 四、信息保护</div>
        <div>
          中国服装设计师协会依法保护会员信息安全，不会擅自公开或向第三方披露会员的注册信息，但下列情形除外：
        </div>
        <div>1、已事先获得会员的明确授权；</div>
        <div>2、根据有关的法律法规的相关规定；</div>
        <div>3、按照相关政府主管部门的要求；</div>
        <div>4、为维护社会公共利益和安全；</div>
        <div>5、为维护中国服装设计师协会的合法权益或进行相关统计、分析、核验工作。</div>
        <div>五、免责条款</div>
        <div>
          中国服装设计师协会将采取合理措施保护会员注册信息安全，防范未经许可的第三方获取您提供的信息。在下列情况下，中国服装设计师协会不承担任何责任：
        </div>
        <div>
          1、由于您将会员账号、密码告知他人或与他人共享注册帐户或您的会员账号、密码被盗或被篡改等导致的任何会员注册信息泄露;
        </div>
        <div>
          2、任何由于不可抗力、黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营原因而造成的会员注册信息泄露、丢失、被盗用或被篡改等;
        </div>
        <div>3、由于与本网站链接的其他网站所造成会员注册信息泄露及由此而导致的任何法律争议和后果。</div>
        <div>五、法律</div>
        <div>
          1、中国服装设计师协会保留对本协议的最终解释权。.本协议条款的修改、更新及免责解释权归中国服装设计师协会所有。本网站有权随时更新本协议，并在更新后在网站公告。会员在使用本网站服务前应仔细阅读最新协议内容。会员对内容有异议的，应在合理期限内向本网站提出异议，否则，将被视为会员接受更新后的协议内容。
        </div>
        <div>
          2、本协议自会员注册本网站账号时生效，有效期与会员在本网站的账号有效期限一致。会员在账号有效期内应遵守本协议规定。会员账号终止时，本协议相应终止。
        </div>
        <div>
          协议2、本协议协议根据中华人民共和国法律法规制定，适用中华人民共和国法律法规。若本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，或违反任何适用的法律，则该条款被视为删除。但本协议的其余条款仍应有效并且有约束力。
        </div>
        <div>
          3、对于任何因本协议引起或与本协议有关的争议及纠纷，双方应通过协商解决；如不能达成一致，任何一方可向中国服装设计师协会所在地有管辖权的人民法院提起诉讼。
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Privacy_Agreement_show = false" size="medium">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  getVerify,
  login,
  getLocationTree,
  getPhoneCode,
  getmyMenu,
  register,
  ccompanyTypeList, SignInaccount, DictLists, Login_checkCaptcha, Login_sendCode, Login_forgotPasswd, SinglePageDetail,
} from "@/api/api";
import {setCookie, getCookie, delCookie} from '../utils/util'
import {Message} from "element-ui";

export default {
  name: 'login',
  data() {
    return {
      Privacy_Agreement_show: false,
      committee_text_show: false,
      top_link_show: false,
      top_link_content: '',
      synopsis: '',
      forget_form: {},
      image: '',
      img_code_dis: false,
      password: '',
      signIn: true,
      passwordShow: 'password',
      password_flag: false,
      imgUrl: require("../assets/right.png"),
      dialogVisible: false,
      //定义loading默认为false

      logining: false,
      // 记住密码
      rememberpwd: false,
      // 同意
      agree: false,
      ccompanyList: [],
      typeList: [{
        id: '1',
        name: '个人委员会'
      }, {
        id: '2',
        name: '单位委员会'
      }],
      // 注册
      registerForm: {
        account: '',
        password: '',
        channel: '9',//1-微信小程序 2-微信公众号 3-手机H5 4-电脑PC 5-苹果APP 6-安卓APP 7-百度推广 8-SoSee推广 9-测试
        password_confirm: '',
        sms_code: '',
        img_code: '',
        type: '1',
        committee_id: '',
        committee_title: '',
      },
      // 登录
      ruleForm: {
        type: '1',
        scene: '1',
        account: '',
        password: '',
        terminal: 4,
        sms_code: 12345,
      },
      countdown: 60,
      // 注册验证
      registerRules: {
        sms_code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
        password_confirm: [{required: true, message: '请再次输入密码', trigger: 'blur'}],
        committee_id: [{required: true, message: '请选择', trigger: ['blur', 'change']}],
        type: [{required: true, message: '请选择', trigger: ['blur', 'change']}],
        account: [{required: true, message: "请输入手机号", trigger: "blur"}, {
          pattern: /^1[3-9]\d{9}$/,
          message: "手机号码格式不正确",
          trigger: "blur",
        },],
      },

      //rules前端验证
      rules: {
        account: [{required: true, message: "请输入手机号", trigger: "blur"}, {
          pattern: /^1[3-9]\d{9}$/,
          message: "手机号码格式不正确",
          trigger: "blur",
        },],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
        code: [{required: true, message: '请输入验证码', trigger: 'blur'}]
      },
      forget_form_rules: {
        account: [{required: true, message: "请输入手机号", trigger: "blur"}, {
          pattern: /^1[3-9]\d{9}$/,
          message: "手机号码格式不正确",
          trigger: "blur",
        },],
        sms_code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
        password_confirm: [{required: true, message: '请再次输入密码', trigger: 'blur'}],
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    this.getImg_code()
    // 获取存在本地的用户名密码
    this.getuserpwd()
    //获取分会列表
    this.GetccompanyType()

  },
  methods: {
    GetccompanyType(type) {
      let types = type ? type : this.registerForm.type
      let data = this.$qs.stringify({type: types});
      ccompanyTypeList(data).then(res => {
        if (res.code == 1) {
          this.ccompanyList = res.data.lists
          localStorage.setItem('ccompanyList', JSON.stringify(res.data.lists))
        }
      }).catch((err) => {
        console.log(err.message)
      })
    },
    type_change() {

      this.registerForm.committee_id = ''
      this.ccompanyList = []
      this.GetccompanyType()
    },
    committeeTitle(e) {
      let title = null
      title = this.ccompanyList.filter((item) => {
        return item.id == e
      })
      this.registerForm.committee_title = title[0].name
      this.synopsis = title[0].synopsis
      this.committee_text_show = true
    },
    handleClick() {

    },
    open() {
      this.dialogVisible = true;
    },
    open_see() {
      this.Privacy_Agreement_show = true;
    },
    imgUrlMouseenter() {
      this.imgUrl = require("../assets/right_pink.png")
    },
    imgUrlMouseleave() {
      this.imgUrl = require("../assets/right.png")
    },
    getImg_code() {
      getVerify().then(res => {
        if (res.code == 1) {
          this.image = res.data.img
        } else {
          Message.error(res.msg);
        }
      })
    },
    forgotPasswd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true;
          let params = this.forget_form
          params.type = this.ruleForm.type
          params.scene = "ZHDLMM"
          Login_forgotPasswd(params).then((res) => {
            this.logining = false;
            if (res.code == 1) {
              this.forget_form = {}
              Message.success(res.msg);
              this.dialogVisible = false
            }
          }).catch((err) => {
            this.logining = false;
            console.log(err);
          });

        }
      })

    },

    getFlag(scene, form) {
      if (form.account.length > 0 && form.img_code.length > 0) {
        // const dis = await this.checkCaptcha()
        // if (dis) {
        let data = {
          scene: scene,
          img_code: form.img_code,
          mobile: form.account,

        }
        Login_sendCode(data).then(res => {
          if (res.code == 1) {
            Message.success('验证码发送成功，请注意查收')
            this.timer()
          } else {
            this.forget_form.img_code = ''
            this.registerForm.img_code = ''
            this.getImg_code()
          }
        })
        // }
      } else {
        Message.error('请填写手机号及图片验证码');
      }


    },
    // 计时器
    timer() {
      if (this.countdown < 0) {
        this.countdown = 60
        return
      }
      setTimeout(() => {
        this.countdown = this.countdown - 1
        this.timer();
      }, 1000);
    },


    // 验证图形验证码
    // checkCaptcha() {
    //   let data = this.$qs.stringify({
    //     img_code: this.registerForm.img_code
    //   });
    //   return Login_checkCaptcha(data).then(res => {
    //     console.log(res)
    //     if (res.code == 1) {
    //       return true;
    //     } else {
    //       this.registerForm.img_code = ''
    //       this.getImg_code()
    //       // this.$message.error(res.msg);
    //       return false;
    //     }
    //   })
    // },

    registerClick() {
      this.signIn = !this.signIn
      if (!this.signIn) this.GetccompanyType()
    },
    async link_Click(type) {
      const res = await SinglePageDetail(this.$qs.stringify({id: type}))
      this.top_link_show = true
      this.top_link_content = res.data.content

    },
    // 注册
    RegisterAnAccount(formName) {
      if (!this.agree) return Message.warning('请阅读并同意《用户协议》和《隐私协议》');
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true;
          let params = this.registerForm
          params.scene = "YZMDL"
          register(params).then((res) => {
            this.logining = false;
            if (res.code == 1) {
              this.registerForm = {}
              Message.success(res.msg);
              this.registerClick()
            }
          }).catch((err) => {
            this.logining = false;
            console.log(err);
          });

        }
      })

    },

    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.account = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    jsonToFormData(json) {
      const formData = new FormData();
      for (let key in json) {
        formData.append(key, json[key]);
      }
      return formData;
    },
    //登录
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true;
          //this.$store.dispatch("userLogin", false);
          localStorage.removeItem('Flag');
          let params = this.ruleForm
          SignInaccount(params).then(res => {
            if (res.code == 1) {
              this.GetccompanyType(this.ruleForm.type)
              let loginRes = {
                token: res.data.token,
                isLogin: true
              }
              this.$store.commit('userStatus', loginRes);
              localStorage.setItem("Flag", "isLogin");
              // 缓存token 用户个人信息
              localStorage.setItem('userdata', JSON.stringify(res.data))
              if (this.rememberpwd) {
                //保存帐号到cookie，有效期7天
                setCookie('user', this.ruleForm.account, 7)
                //保存密码到cookie，有效期7天
                setCookie('pwd', this.ruleForm.password, 7)
              } else {
                delCookie('user')
                delCookie('pwd')
              }
              this.getconfigdict()
              this.getLocationTree()
              // this.getPhoneCode()
              this.getmyMenu()
              //如果请求成功就让他2秒跳转路由
              setTimeout(() => {
                this.logining = false

                this.$router.push({
                  path: '/conference'
                })
              }, 1000)
            } else {
              console.log(res.data, "res.data")
              this.$message.warning(res.data.msg)
              this.logining = false
              this.getImg_code()
              return false
            }
          })
              .catch((err) => {
                this.logining = false;
              })
        } else {
          // 获取图形验证码
          this.getImg_code()
          this.$message.error('请输入用户名密码！')
          this.logining = false
          return false
        }
      })
    },
    // 获取左侧菜单
    getmyMenu() {
      let data = this.$qs.stringify({type: JSON.parse(localStorage.getItem("userdata")).type});
      getmyMenu(data).then((res) => {
        if (res.code == 1) {
          let {data} = res;
          this.$store.commit("menuStatus", JSON.stringify(data));
          localStorage.setItem("menu", JSON.stringify(data));
        }
      }).catch((err) => {
        console.log(err);
        // if (err.response.data.code == 401) {
        //   this.$router.push({
        //     path: "/login",
        //   });
        // }
      });
    },
    // 获取字典
    getconfigdict() {
      // DDisplay_subject            陈列-课程方向
      // DDisplay_professional       陈列-专业方向
      // training                    培训类型
      // Technology_subject          技术-课程方向
      // Technology_professional     技术-专业方向
      // designer                    设计师类别
      // education                   学历


      // 品牌
      // belong_brand                   所属品牌
      // member_clothing                    服装
      // member_ornament                   配饰
      // member_platform                   线上店铺(可多选)


      // member_payment_years                  缴费年限
      let data = this.$qs.stringify({
        type: 'DDisplay_subject,' +
            'DDisplay_professional,' +
            'training,Technology_subject,' +
            'Technology_professional,' +
            'designer,education,' +
            'belong_brand,' +
            'member_clothing,' +
            'member_ornament,' +
            'member_brand_category,' +
            'member_platform,' +
            'member_payment_years'
      });
      DictLists(data).then(res => {
        if (res.code == 1) {
          localStorage.setItem('dictdata', JSON.stringify(res.data))
        }

      }).catch(err => {
        console.log(err)
      })
    },
    // 获取国家
    getLocationTree() {
      getLocationTree({}).then(res => {
        if (res.code == 1) {
          let country = []
          country = res.data[0].children

          localStorage.setItem('locationdata', JSON.stringify(country))
        }

      }).catch(err => {
        console.log(err)
      })
    },
    // 获取区号
    getPhoneCode() {

      getPhoneCode({}).then(res => {
        if (res.code == 1) {
          localStorage.setItem('codedata', JSON.stringify(res.data))
        }

      }).catch(err => {
        console.log(err)
      })
    },


  }
}
</script>

<style lang="scss" scoped>
.Privacy_box {
  div {
    line-height: 24px;
  }
}

/deep/ .el-dialog {
  //margin-left: 45%;
  //min-height: 420px;
}

.register_box {
  width: 1020px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  background-color: #fff
}

.register_line {
  margin: 43px 40px;
  height: 530px;
  border-left: 3px solid #E40080;
}

.register_right {
  margin-top: 43px;
  height: 530px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}

.dialog_box {
  font-size: 16px;
  font-weight: bold;
}

.login-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  padding-top: 10%;
  box-sizing: border-box;
  background-image: url('../assets/loginbg.jpg');
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100% 100%;
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 440px;
  padding: 38px 38px 25px;
  box-sizing: border-box;
  background: #fff;
  // border: 1px solid #eaeaea;
  // text-align: left;
  // box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  color: #A9ABBA;
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}

.bottom_box {
  display: flex;
  justify-content: space-between;
}

.wjpass {
  font-weight: 400;
  font-size: 14px;
  color: #A9ABBA;
  //line-height: 22px;
  cursor: pointer;
}

@media only screen and (max-width: 767px) {
  .login-wrap {
    display: flex;
    align-items: center;
    background-size: 100%;
  }

  .login-container {
    width: 70%;
  }

}

.icon_see {
  background-image: url("../assets/see.png");
}

.icon_close {
  background-image: url("../assets/nosee.png");
}

.register_class:hover {
  color: #E40080;
}

.register_class {
  line-height: 22px;

  font-size: 14px;
  cursor: pointer;
}

._center {
  text-align: center;
}

.top_link {
  margin: 30px 0;
  color: #83727C
}

.bottom_view {
  width: 250px;
  height: 120px;
  background: #F2F6FB;
  border-radius: 10px;
  padding: 15px;

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
}

/deep/ .el-tabs__nav-wrap::after {
  display: none;
}

/deep/ .el-tabs__header {
  display: flex;
  justify-content: center;
}

/deep/ .el-tab-pane {
  display: none;
}

/deep/ .el-tabs__active-bar {
  background-color: #E40080;
}

/deep/ .is-active {
  font-weight: 500;
  font-size: 18px;
  color: #000000;
}

/deep/ .el-input__inner {
  height: 52px;
}

.verification /deep/ .el-form-item__content {
  display: flex;
}

/deep/ .el-form-item {
  margin-bottom: 15px !important;
}

/deep/ .el-form-item__error {
  font-size: 10px !important;
}

/deep/ .el-dialog__footer {
  text-align: center;
}
</style>